import React from 'react';

import ListManager from '@/Shared/list/ListManager'
import { Inertia } from '@inertiajs/inertia';
import { Row, ListGroup, Dropdown, InputGroup, FormControl, Badge} from 'react-bootstrap';
import {currParams, createURI, paramsObj} from '@/utils';
import Loading from '@/Shared/General/Loading';


class ListInput extends ListManager {

	constructor(props) {
		super(props);
		const params = currParams();
		this.state = {...this.state, 
			showList: false,
			searched: true,
		}
		if (typeof this.state.value == 'undefined' && !this.props.noInputFromParam && params.has(this.props.searchParam)) {
			this.state.value = params.get(this.props.searchParam)||'';
		}
	}
	
	deselectOnChange = () => !this.props.preserveSelected
	
	setWaiting = (val) => this.setState({waiting: val})
	
	static inertiaSearchCancelToken = null;
	
	searchTimeout = null;
	
	canSearchEmpty = () => !this.props.noSearchEmpty;
	
	searchVal = ({delay=(this.props.searchMinDelay)}={}) => {
		if (!this.value() && !this.canSearchEmpty()) return;
		if (this.isSelected() && !this.props.searchValue) return; 
		if (typeof delay!=="number") delay = delay ? 1 : 250;
		if (this.props.searchParam) {
			const params = paramsObj();
			//currParams();
			params[this.props.searchParam] = undefined;
			params['x_'+this.props.searchParam] = undefined;
			//params.delete(this.props.searchParam);
			params.remember = undefined
			//params.delete('remember');
			if (this.isSelected()) {
				params['x_'+this.props.searchParam] = this.props.value
			} else if (this.state.value) {
				params[this.props.searchParam] = this.state.value
				//params.set(this.props.searchParam, this.state.value);
			} else {
				//params.remember = 'forget'
				//params.set('remember', 'forget');
			}
		  /*const query = Object.keys(pickBy(values)).length
		    ? pickBy(values)
		    : { remember: 'forget' };*/
			const query = params
			//params.toString();
			this.setWaiting(true)
			clearTimeout(this.searchTimeout);
			if (ListInput.inertiaSearchCancelToken) {
				ListInput.inertiaSearchCancelToken.cancel();
				ListInput.inertiaSearchCancelToken = null;
			}
			this.searchTimeout = setTimeout(()=>{
				const only = (this.isSelected() && this.props.onlySearchVal) || this.props.onlySearch || [];
				Inertia.reload(// Hacer que la url sea sincronizada con los valores de los inputs o vals
				{
					data: query,
					only: only!=0 ? only.concat(['flash']) : only,
					onCancelToken: (cancelToken) => (ListInput.inertiaSearchCancelToken = cancelToken),
					onFinish: ()=>{
						if (this.isMounted()) this.setWaiting(false);
					}
				})
			}, delay||1);
		}
	}
	
	componentDidUpdateExtend = (prevProps, prevState) => {
		if (this.state.value!==prevState.value && (!this.isSelected() || this.props.searchValue)) {
			this.searchVal();
		}
		
		if (this.isSelected() && this.props.selFromList && (!_.isEqual(prevProps.list, this.props.list))) {
			const data = ListInput.getListData(this.props);
			const item = data.find(itm=>itm&&itm[this.keyVal()]==this.state.itemSel[this.keyVal()]);
			if (!item) {
				this.removerSeleccion();
			}
		}
		if (!prevProps.formMounted && this.props.formMounted) {
			// this.usedMountedForm = true;
			if (this.props.inputValue==undefined && this.state.value) {
				this.onSelect(undefined, this.state.value);
			}
		}
	}
	
	componentDidMountExtend = () => {
		//const params = currParams();
		//if (this.deselectOnChange() && params.has(this.props.searchParam)) {
			//console.log(params.get(this.props.searchParam), this.props.value);
			//this.onSelect(undefined, params.get(this.props.searchParam)||'');
		//}
		/* if (this.props.inputValue==undefined && this.state.value) {
			this.onSelect(undefined, this.state.value);
		} */
	}
	
	inputElement = this.props.inputProps?.ref || this.props.inputRef || React.createRef();
	
	//showCeroOnEmpty = () => !this.props.dontShowCeroInnerOnEmpty
	
	getCeroCoincidenciasSelected = () => {
		return <Dropdown.Item disabled as="span" className="text-muted" {...this.props.ceroInnerPropsSelected}>{(!this.value()&&this.props.ceroInnerEmptySelected)||this.props.ceroInnerSelected||'Edita para buscar más coincidencias'}</Dropdown.Item>
	}
	
	getCeroCoincidencias = () => {
		return !this.isSelected() ? <Dropdown.Item disabled as="span" className="text-muted" {...this.props.ceroInnerProps}>{(!this.value()&&this.props.ceroInnerEmpty)||this.props.ceroInner||'0 coincidencias'}</Dropdown.Item> : this.getCeroCoincidenciasSelected();
	}
	
	canShowList = () => true;

	showList = () => {
		if (this.canShowList()) {
			clearTimeout(this.blurTimeout);
			if (!this.state.showList) this.setState({showList: true}, () => {
				if (this.props.searchOnShow) this.searchVal({delay:0});
			});
		}
	}

	hideList = (e) => {
		// console.log(e.target, e.currentTarget, e)
		this.setState({showList: false});
	}

	blurTimeout = null

	blurInput = (e) => {
		this.blurTimeout = setTimeout(()=>{
			if (this.isMounted()) this.setState({showList: false});
		}, 250);
	}

	toggleShow = () => {
		// console.log("show list", this.state.show);
		clearTimeout(this.blurTimeout);
		// this.setState((p)=>({show: !p.show}));
		if (this.state.showList) this.hideList();
		else this.showList();
	}
	
	isShowList = () => !!this.state.showList;
	
	isWaiting = () => !!this.state.waiting;
	
	isSearched = () => !!this.state.searched;
	
	pasarPropsComoItem = () => true;
	
	value = () => this.state.value;
	
	keyVal = () => this.props.keyVal
	keyCnt = () => this.props.keyCnt;
	
	getKey = () => {
		return this.keyVal()||ListManager.handler(this, '$', 'keyName');
	}
	
	getName = () => this.props.inputProps?.name||'';
	
	isSelectable = () => !this.props.noSelectable
	
	Item = React.forwardRef((props, ref) => {
		const {content: Content} = this.props;
		const {item={}, ...rest} = props;
		const value = item[this.keyVal()];
		const isActive = this.value()===value;
		const defInner = item[this.keyCnt()];
		const children = Content ? <Content {...props} value={value} keyCnt={this.keyCnt()}  
				active={isActive}
			>{defInner}</Content> : defInner;
			
		const onClick = () => this.isSelectable() && this.selectItem(item)
			
		return <Dropdown.Item as={this.ItemBase} keyCnt={this.keyCnt()} active={isActive} value={value} children={children} onClick={onClick} {...props} />
	});
	
	localSelected = undefined;
	
	localInputVal = undefined;
	
	onSelect = (item, defValue = '') => {
		let lastValue = this.value();
  		const newValue = item ? item[this.keyCnt()] : defValue
		this.localSelected = item;
  		if (newValue===lastValue) this.localInputVal = newValue;
  		const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
  		nativeInputValueSetter.call(
  			this.inputElement.current, newValue+(newValue===lastValue?" ":'')
  		);
  		const event = new Event("input", { bubbles: true });
  		event.simulated = true;
  		//event.removeFile = true;
  		let tracker = this.inputElement.current?._valueTracker;
		if (tracker) {
		  tracker.setValue(lastValue);
		}
	    this.inputElement.current?.dispatchEvent(event);
	}
	
	onChangeInput = (e) => {
		const targetVal = e.target.value
		/* console.log('change', {type: 'list', 
			val: this.localSelected ? this.localSelected[this.keyVal()] : this.props.inputEqualVal ? targetVal : undefined,
			item: this.localSelected,
			input: typeof this.localInputVal!=='undefined'?this.localInputVal:targetVal,
		}); */
		this.props.inputProps?.onChange(e, {type: 'list', 
			val: this.localSelected ? this.localSelected[this.keyVal()] : this.props.inputEqualVal ? targetVal : undefined,
			item: this.localSelected,
			input: typeof this.localInputVal!=='undefined'?this.localInputVal:targetVal,
		})
		if (this.localSelected) this.localSelected = undefined;
		if (this.localInputVal) this.localInputVal = undefined;
	}
	
	selectItem = (item) => {
		this.hideList();
		this.onSelect(item);
		//if (this.props.onSelect) this.props.onSelect(this.getName(), item[this.keyVal()], item[this.keyCnt()])
	}
	
	removerSeleccion = () => {
		this.hideList();
		this.onSelect(undefined, this.props.preserveInput ? this.value() : '');
		this.inputElement.current?.focus();
		//if (this.props.onSelect) this.props.onSelect(this.getName(), undefined, '')
	}
	
	hasVal = () => typeof this.props.value !== 'undefined'
	
	ItemBase = React.forwardRef((props, ref) => {
		const {value, children, onClick, itemProps, ...rest} = props;
		return <Dropdown.Item as="button" type="button" ref={ref} onClick={onClick} {...itemProps}>
			{children||value}
		</Dropdown.Item>
	});
	
	getVariant = () => ListManager.VARIANT_LISTA
	
	getListaVariantCnt = () => {
		const items = this.getEleItems();
		return <Dropdown.Menu align="right" className="w-100">
			{ this.isWaiting() ? <Dropdown.Item disabled className="text-center" key={"load-list-itm"}>
				<Loading
					as="span"
					animation="border"
					size="sm"
					role="status"
					aria-hidden="true"
				/>
			</Dropdown.Item> : (this.isSearched() ? !items.length && 
				this.getCeroCoincidencias() : 
				<Dropdown.Item as="span" disabled className="text-muted">Esperando para buscar</Dropdown.Item> )}
			{items}
		</Dropdown.Menu>
	}
	
	isSelected = () => !!(!this.props.inputEqualVal ? this.props.value : this.state.itemSel)
	
	static getListData = (props) => {
		return (Array.isArray(props.list) ? props.list : props.list?.data)||[];
	}
	
	static getDerivedStateFromProps(props, state, {listChanged}={}) {
		const newState = {};
		if (typeof props.inputValue != 'undefined' && !_.isEqual(props.inputValue, state.value)) {
			newState.value = props.inputValue;
		}
		
		//if (props.inputEqualVal) props.value
		
		if (/*(!props.inputEqualVal || !props.alterValue) &&*/ props.value && (
			!props.inputValue || !state.itemSel || 
			state.itemSel[props.keyVal]!=props.value/* || listChanged /*(
				Array.isArray(props.list) ? 
			) /*&& props.list && props.keyVal*/
		)) {
			const list = ListInput.getListData(props);
			const itemSel = !state.itemSel || state.itemSel[props.keyVal]!=props.value ? list.find(itm=>itm[props.keyVal]==props.value)||(props.defItem && props.defItem[props.keyVal]==props.value ? props.defItem : undefined) : state.itemSel;
			newState.value = itemSel ? itemSel[props.keyCnt] : (props.inputEqualVal ? props.value : 'cargando...');
			newState.itemSel = itemSel;
		} else if (typeof props.value=='undefined' && state.itemSel) {
			newState.itemSel = undefined;
		}
		if (Object.keys(newState)!=0) return {...newState};
		return null;
	}

	renderBase = ({withModalProps={}, dropdownProps={}, inputProps: {onChange, className: inputClass, ...inputProps}, dropdownToggleProps, dropdownAppend, ...props}=this.props) => {
		withModalProps.noCnt = true;
		const viewlist = this.getViewList();
		const {WithModal} = this;
		inputClass = 'list-input'+(this.isSelected()?" selected":'')+(inputClass?' '+inputClass:"");
		const input = <>
			<FormControl
				ref={this.inputElement} value={this.state.value||""}
				onFocus={this.showList} autoComplete="off" onBlur={this.blurInput}
				onClick={this.showList} /*className={this.getClassName()}*/
				className={inputClass}
				{...inputProps} onChange={this.onChangeInput}
				readOnly={inputProps?.readOnly||this.isSelected()}
			/>
			{ this.isSelected() && <div className="right-info-input">
				<Badge role="button"
					variant="info" onClick={this.removerSeleccion}
				>{this.props.deselectBtnCnt||'Deseleccionar'}</Badge>
			</div>}
		</>
		//!this.props.noToggle
		dropdownProps.className=(this.props.noToggle?"no-toggle":"")+(dropdownProps.className?" "+dropdownProps.className:"")
		return <WithModal {...withModalProps}>
			<Dropdown show={this.isShowList()} as={InputGroup}
				{...dropdownProps}
			>
				{input}
				<InputGroup.Append>
					<Dropdown.Toggle split variant="secondary" /*id={"dropdown-toggle"+this.uniqueVal}*/ onClick={this.toggleShow} {...dropdownToggleProps} />
					{dropdownAppend}
				</InputGroup.Append>
				{props.feedback}
				{viewlist}
			</Dropdown>
		</WithModal>
	}
}

export default ListInput
